// src/services/questionResponseService.js
import { questionResponsesAPI } from './api';

export const questionResponseService = {
  // Get all surveys for dropdown selection
  async getSurveys() {
    try {
      console.log('🔄 Fetching surveys for dropdown');
      const response = await questionResponsesAPI.getSurveys();
      console.log('✅ Surveys loaded:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching surveys:', error);
      throw new Error('Failed to load surveys: ' + error.message);
    }
  },

  // Get employees by survey
  async getEmployeesBySurvey(surveyId) {
    try {
      console.log('🔄 Fetching employees for survey:', surveyId);
      const response = await questionResponsesAPI.getEmployeesBySurvey(surveyId);
      console.log('✅ Employees loaded:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching employees:', error);
      throw new Error('Failed to load employees: ' + error.message);
    }
  },

  // Get detailed question responses by employee and survey
  async getEmployeeQuestionResponses(surveyId, employeeId) {
    try {
      console.log('🔄 Fetching question responses for survey:', surveyId, 'employee:', employeeId);
      const response = await questionResponsesAPI.getEmployeeDetails(surveyId, employeeId);
      console.log('✅ Question responses loaded:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching question responses:', error);
      throw new Error('Failed to load question responses: ' + error.message);
    }
  },

  // Get question responses summary for multiple employees
  async getQuestionResponsesSummary(surveyId, employeeIds = []) {
    try {
      console.log('🔄 Fetching question responses summary for survey:', surveyId, 'employees:', employeeIds);
      const response = await questionResponsesAPI.getSummary({ surveyId, employeeIds });
      console.log('✅ Question responses summary loaded:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching question responses summary:', error);
      throw new Error('Failed to load question responses summary: ' + error.message);
    }
  },

  // Export question responses
  async exportQuestionResponses(surveyId, employeeIds = []) {
    try {
      console.log('🔄 Exporting question responses for survey:', surveyId, 'employees:', employeeIds);
      const response = await questionResponsesAPI.exportResponses({ surveyId, employeeIds });
      
      if (!(response.data instanceof Blob)) {
        throw new Error('Export response is not a Blob');
      }
      
      // Create download link
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.download = `question-responses-survey-${surveyId}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      console.log('✅ Question responses exported successfully');
      return { success: true, message: 'Question responses exported successfully' };
    } catch (error) {
      console.error('❌ Error exporting question responses:', error);
      throw new Error('Failed to export question responses: ' + error.message);
    }
  }
};